import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styles from './UpcomingEvents.module.scss';
import messages from './UpcomingEvents.intl';
import DateAndTitleListItem from '../DateAndTitleListItem/DateAndTitleListItem';

const UpcomingEvents = ({ upcomingEventData, displayTitle, intl }) => (
  <div>
    {displayTitle && (
      <h2 className={styles.Header}>
        {intl.formatMessage(messages.newsEvents)}
      </h2>
    )}
    {upcomingEventData &&
      upcomingEventData.map(({ date, subtitle, title, link }, index) => (
        <DateAndTitleListItem
          key={index}
          date={date}
          link={link}
          title={title}
          subtitle={subtitle}
          targetBlank={true}
        />
      ))}
  </div>
);

export default injectIntl(UpcomingEvents);

UpcomingEvents.propTypes = {
  upcomingEventData: PropTypes.array,
  displayTitle: PropTypes.bool
};

UpcomingEvents.defaultProps = {
  upcomingEventData: [],
  displayTitle: false
};



// WEBPACK FOOTER //
// ./src/common/components/UpcomingEvents/UpcomingEvents.js